import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Envasado/imprimirEnvasado`, method: 'POST', body: list, token: token})
}